import React from 'react'
import styled from 'styled-components';

function Schedule() {
  return (
    <Div>
      <Div2>
        <h2>Fixtures</h2>
        <table>
          <tr>
            <td>S/N</td>
            <td>MATCH</td>
            <td>DATE</td>
            <td>RESULT</td>
          </tr>
          
          <tr>
            <td>1</td>
            <td>WildWest Ballers - The Underdogs</td>
            <td>16/09/2023</td>
            <td>43 - 41</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Travis Mavericks - Just Doodles</td>
            <td>16/09/2023</td>
            <td>28 - 39</td>
          </tr>
          <tr>
            <td>3</td>
            <td>Team Ace - Kpako BC</td>
            <td>23/09/2023</td>
            <td>73 - 55</td>
          </tr>
          <tr>
            <td>4</td>
            <td>WildWest Ballers - Travis Mavericks</td>
            <td>23/09/2023</td>
            <td>66 - 53</td>
          </tr>
          <tr>
            <td>5</td>
            <td>Team Ace - Hoop Pirates</td>
            <td>30/09/2023</td>
            <td>46 - 38</td>
          </tr>
          <tr>
             <td>6</td>
            <td>Just Doodles - Kpako BC</td>
            <td>30/09/2023</td>
            <td>38 - 33</td>
          </tr>
          <tr>
            <td>7</td>
            <td>The Underdogs - Travis Mavericks</td>
            <td>07/10/2023</td>
            <td>49 - 47</td>
          </tr>
          <tr>
            <td>8</td>
            <td>Hoop Pirates - Kpako BC</td>
            <td>07/10/2023</td>
            <td>54 - 36</td>
          </tr>
          <tr>
            <td>9</td>
            <td>WIldWest Ballers - Just Doodles</td>
            <td>14/10/2023</td>
            <td>47 - 50</td>
          </tr>
          <tr>
            <td>10</td>
            <td>The Underdogs - Team Ace</td>
            <td>14/10/2023</td>
            <td>44 - 45</td>
          </tr>
          <tr>
            <td>11</td>
            <td>The Underdogs - Just Doodles</td>
            <td>21/10/2023</td>
            <td>40 - 41</td>
          </tr>
          <tr>
            <td>12</td>
            <td>WildWestest Ballers - Hoop Pirates</td>
            <td>21/10/2023</td>
            <td>73 - 53</td>
          </tr>
          <tr>
            <td>13</td>
            <td>WildWest Ballers - Team Ace</td>
            <td>28/10/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>14</td>
            <td>Just Doodles - Hoop Pirates</td>
            <td>28/10/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>15</td>
            <td>Skills Challenge</td>
            <td>31/10/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>16</td>
            <td>Dunk Contest</td>
            <td>31/10/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>17</td>
            <td>3Pt Contest</td>
            <td>04/11/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>18</td>
            <td>All-Star Game</td>
            <td>04/11/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>19</td>
            <td>Travis Mavericks - Kpako BC</td>
            <td>18/11/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>20</td>
            <td>The Underdogs - Kpako BC</td>
            <td>18/11/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>21</td>
            <td>Travis Mavericks - Hoop Pirates</td>
            <td>25/11/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>22</td>
            <td>WildWest Ballers - Kpako BC</td>
            <td>25/11/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>23</td>
            <td>The Underdogs - Hoop Pirates</td>
            <td>02/12/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>24</td>
            <td>Just Doodles - Team Ace</td>
            <td>02/12/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>25</td>
            <td>Contest</td>
            <td>09/12/2023</td>
            <td></td>
          </tr>
          <tr>
            <td>26</td>
            <td>Travis Mavericks - Team Ace</td>
            <td>09/12/2023</td>
            <td></td>
          </tr>

        </table>
      </Div2>
    </Div>
  )
}

export default Schedule


const Div = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
width: 100%;

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
`

const Div2 = styled.div`
height: 100vh;
width: 100%;
`
